// src/pages/Login.js
import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate, Link } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(''); // State for success message
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); // Clear previous errors
    try {
      await signInWithEmailAndPassword(auth, email, password);
      
      // Show success message and wait briefly before redirecting
      setSuccess("Login Successful");
      setTimeout(() => {
        navigate('/inventory'); 
      }, 1500); // 1.5 second delay

    } catch (err) {
      setError('Failed to login. Please check your credentials.');
      console.error(err);
    }
  };

  return (
    <div className="container" style={{ padding: '100px 20px', maxWidth: '500px' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Login</h2>
      
      {/* Error Message */}
      {error && (
        <div style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>
          {error}
        </div>
      )}

      {/* Success Message */}
      {success && (
        <div style={{ backgroundColor: '#d4edda', color: '#155724', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>
          {success}
        </div>
      )}

      <form onSubmit={handleLogin} style={{ border: '1px solid #ddd', padding: '30px', borderRadius: '8px', background: 'white' }}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <div style={{textAlign: 'right', marginTop: '5px'}}>
             <Link to="/forgot-password" style={{fontSize: '0.9rem', color: 'var(--accent-blue)'}}>Forgot Password?</Link>
          </div>
        </div>

        <button 
          type="submit" 
          className="btn btn-primary"
          style={{ width: '100%', padding: '12px', fontSize: '1rem' }}
        >
          Sign In
        </button>
      </form>
      <p style={{marginTop: '20px', textAlign: 'center'}}>
        Don't have an account? <Link to="/signup" style={{color: 'var(--accent-blue)'}}>Create one here</Link>
      </p>
    </div>
  );
};

export default Login;